// This function allow to reference all chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 0) return "0.ec70c9fb911b5a32f474.chunk.js";
	// return url for filenames based on template
	return "" + chunkId + "." + {"antd":"cedefb6fd1ed3c7784ab","documents":"d3378171cb2fadc132c8","charts":"787927272e310efff80b","vendors":"ccd3591c47c10b165852","main":"31b7bde0ccedbf5fc918"}[chunkId] + ".js";
};